interface Props {
  [key: string]: any
}

export default function EyeClosedIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} fill="none" viewBox="0 0 26 26">
      <g clipPath="url(#clip0_18_2308)">
        <path
          className={pathClassName ? `fill-current ${pathClassName}` : ''}
          d="M15.9319 12.6791C15.912 11.8489 15.569 11.0592 14.9759 10.478C14.3828 9.89677 13.5863 9.56986 12.7559 9.56677L15.9319 12.6791Z"
          fill="white"
        />
        <path
          className={pathClassName ? `fill-current ${pathClassName}` : ''}
          d="M10.4594 7.52591C11.1801 7.19558 11.9626 7.0217 12.7553 7.01569C14.2776 7.01569 15.7376 7.62043 16.814 8.69687C17.8905 9.77331 18.4952 11.2333 18.4952 12.7556C18.4948 13.4318 18.3694 14.1021 18.1253 14.7327L21.6841 18.0363C23.2729 16.5259 24.5701 14.7358 25.5107 12.7556C25.5107 12.7556 21.6841 3.82686 12.7553 3.82686C10.9965 3.81764 9.2563 4.18743 7.65319 4.91107L10.4594 7.52591ZM2.55106 2.55133L1.27553 3.82686L4.52814 6.88814C2.62226 8.50311 1.07917 10.5026 0 12.7556C0 12.7556 3.8266 21.6843 12.7553 21.6843C14.8207 21.6928 16.8554 21.1842 18.6738 20.2047L22.9596 24.2354L24.2351 22.9599L2.55106 2.55133ZM12.7553 18.4955C11.233 18.4955 9.77304 17.8907 8.69661 16.8143C7.62017 15.7379 7.01543 14.2779 7.01543 12.7556C7.02247 11.7696 7.28624 10.8025 7.78075 9.94942L9.73231 11.7862C9.62724 12.0988 9.5713 12.4258 9.56649 12.7556C9.5652 13.2747 9.69119 13.7863 9.93342 14.2455C10.1757 14.7046 10.5268 15.0974 10.956 15.3894C11.3852 15.6815 11.8795 15.8638 12.3955 15.9206C12.9116 15.9773 13.4336 15.9066 13.9161 15.7148L15.8804 17.5643C14.9516 18.1723 13.8654 18.496 12.7553 18.4955Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_18_2308">
          <rect
            className={pathClassName ? `fill-current ${pathClassName}` : ''}
            fill="white"
            height="25.5107"
            width="25.5107"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
